import axios from "axios";
import {getSelfToken} from '../../_helpers/auth/secureToken'
import {AlbumEndpoint} from '../_constants/api.constant'
export async function getPlatformList() {
    const response = await axios.get(
        AlbumEndpoint.GET_ALL_PLATFORM,
        {  
            //  params:paramsObj,
            headers: {
                'Authorization': 'Token ' + getSelfToken(),
            },
        }
    ).then(function (response) {
        return response;
    }).catch(function (error) {
        return error.response;
    });
    return response;
}